export type AgeGenderData = {
    current: AgeGenderProperties;
    versus: Pick<AgeGenderProperties, 'nbPerson'>;
    comparison: Pick<AgeGenderProperties, 'nbPerson'>;
};

export type AgeGenderProperties = {
    nbPerson: number;
    gender: GenderData;
    age: AgeData;
};

export interface AgeData {
    adult: number;
    child: number;
}

export interface GenderData {
    men: number;
    women: number;
}

export interface Range {
    begin: number;
    end: number;
}

export interface ExceptionData {
    exception: string;
}
